import { defineComponent, ref } from 'vue';
import { CaretLeftOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'ItemDetailNavBar',
  components: {
    CaretLeftOutlined: CaretLeftOutlined
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  setup: function () {
    var visible = ref(true);
    var toggle = function () {
      visible.value = !visible.value;
    };
    return {
      visible: visible,
      toggle: toggle
    };
  }
});